import defaultThemeImg from '../assets/images/theme-img/default.jpg'
import darkThemeImg from '../assets/images/theme-img/dark.jpg'
// notification提示组件的全局配置
export const notificationConfig = {
  placement: 'bottomRight',
  bottom: '50px',
  duration: 3
}
// message提示组件的全局配置
export const messageConfig = {
  top: `65px`,
  duration: 2,
  maxCount: 3
}

// 围栏颜色配置
export const notAllowedInFenceStyle = {
  strokeColor: 'red',
  strokeWeight: 4,
  strokeOpacity: 0.9,
  fillOpacity: 0.45,
  fillColor: 'red'
}

export const notAllowedOutFenceStyle = {
  strokeColor: 'green',
  strokeWeight: 4,
  strokeOpacity: 0.9,
  fillOpacity: 0.45,
  fillColor: 'green'
}

// 主题配置
export const themes = [
  {
    image: defaultThemeImg,
    title: '默认主题',
    description: '这是一款默认主题以白色和深蓝为主,主要为了表现简洁而不失庄严的特色',
    class: 'default',
  },
  {
    image: darkThemeImg,
    title: '深色主题',
    description: '这是一款以蓝白相间的主题，主要以深色为主，看起来爆丑！',
    class: 'custom',
  }
]

// 首页marker文字标注的样式
export const markerLabelStyle = {
  borderRadius: '5px',
  border: '1px solid #666',
  background: '#fff',
  padding: '4px 6px',
}

// label文字标注不显示的样式
export const hideLabelStyle = {
  display: 'none'
}

// 透明label样式
export const transparencyLabelStyle = {
  background: 'rgba(25, 55, 119, 0.815)',
  // background: 'rgba(255, 255, 255, 0.2)',
  border: '.5px solid #ccc',
  borderRadius: '5px',
  padding: '4px 4px 0 4px',
  color: '#fcfcfc'
  // width: '10px',
  // textAlign: 'center',
}

export default {
  notificationConfig,
  messageConfig,
  themes,
  markerLabelStyle
}